const riot = require('riot');

riot.tag2('module-view-inbox', '<div class="f fclm s-full"> <div class="flex-fixed px16 mb10" data-is="module-note-filter" ref="filter" users="{users}" enable-closed="{true}"></div> <div class="s-full px16 pb16 s-px8 overflow-hidden"> <div class="f s-full bg-white box-shadow-primary rounded-12 overflow-hidden"> <div class="flex-fixed w280 bg-background_light_secondary overflow-scroll scrollbar-none s-w-full" ref="notes" onscroll="{onScroll}"> <div class="f fm fbw border-bottom bg-background_light_secondary py6 px12 sticky t0 z1 s-hide"> <div class="mr16">件数: {activeInboxes.length >= limit ? (limit-1) + \'+\' : activeInboxes.length}</div> <div class="f fm py6 cursor-pointer s-hide" onclick="{toggleUnreadFilter}"> <div class="fs12 mr6">未読メッセージ</div> <div data-is="atom-switch" ref="unread_switch" checked="{isUnreadFiltered()}" is-alert="{true}"></div> </div> </div> <div> <div class="border-bottom bg-white" if="{activeInboxes.length}" each="{inbox in activeInboxes}" data-is="item-note" item="{inbox.relation.note}" is-current="{inbox.relation.note.id === parent.currentInbox.relation.note.id}" enable-active-border="{true}" show-project="{true}" link="{getInboxLink(inbox)}"></div> <div class="f fc fclm p32" if="{shouldShowClosedNoteAnnouncement()}"> <div class="text-center lh16 mb16">更新されたノート、またはクローズされたノートに未読が残っているかもしれません。</div> <button class="relative button primary" onclick="{filterUnreadAndClose}">未読ノートを確認 <div class="absolute tn6 rn6 fh f s18 fs11 circle bg-alert_primary text-white font-lato" if="{app.store.inboxesStore.items.length}">{app.store.inboxesStore.items.length}</div> </button> </div> </div> <div class="p16" data-is="atom-loading" if="{isLoading || isRefreshing}"></div> <div class="sticky b0 z1 px16 pb16" data-is="atom-loading-slow" if="{isLoading || isRefreshing}"></div> </div> <div class="s-full s-hide" data-is="module-note" ref="note"></div> <div class="s-full border-left s-hide" data-is="module-messages" ref="messages"></div> </div> <bottom class="fixed r24 b100 button f fh h40 transition-128 active-anim-scale border border-label_dark_disabled h40 rounded-20 box-shadow-primary mb-safe s-show {isUnreadFiltered() ? \'bg-alert_primary text-white\' : \'bg-pale text-label_dark_primary\'}" type="button" onclick="{toggleUnreadFilter}">未読<i class="icon-close fs20 pl4 pt3 mrn4" if="{isUnreadFiltered()}"></i></bottom> </div> </div>', 'module-view-inbox,[data-is="module-view-inbox"]{display:block}', '', function(opts) {
    this.limit = 64;

    this.loadedInboxes = [];

    this.activeInboxes = [];

    this.on('mount', () => {
      this.refs.filter.on('filterchange', ({ q }) => {

        this.refreshInboxes();

        app.utils.replaceLocationParams({
          q: this.refs.filter.getQueryValue().trim(),
        });

        this.refs.unread_switch.setValue(this.isUnreadFiltered());
      });

      if (spat.isBrowser && !app.useragent.isMobile) {
        app.utils.split([
          this.refs.notes,
          this.refs.note.root,
          this.refs.messages.root,
        ], {
          storageKey: 'split_view_list',
          defaultSizes: [20, 60, 20],
          minSizes: [300, null, 300],
        });
      }
    });

    this.setup = async ({inbox_id}, {req, res, cached}) => {

      app.shortcut.setView('inbox', { noteTag: this.refs.note, viewTag: this });
      if (inbox_id) {
        this.updateCurrentInbox(inbox_id);
      }

      if ((!inbox_id || !this.inboxesStore) && !req.isBack) {

        this.refreshInboxes({ force: true });
      }

      let workspaces_users = await app.store.workspace.fetchWorkspaceUsers();
      this.users = workspaces_users.map(tu => tu.relation.user);

      if (req.query.q) {
        this.refs.filter.setQueryValue(decodeURIComponent(req.query.q));
      }

      this.update();
    };

    this.getInboxLink = (inbox) => {
      if (app.useragent.isMobile) {
        return '';
      }
      else {
        return `/${app.store.workspace.path}/inboxes/${inbox.id}`;
      }
    };

    this.refreshInboxes = async ({ force = false } = {}) => {
      if (!app.store.workspace_user) return ;

      let inboxes_store = this.createInboxesStore(this.refs.filter.getQuery());

      if (!force && this.inboxesQuery?.isEqual(inboxes_store.ref)) {

        if (!this.isRefreshing) {
          this.filterInboxes();
          this.update();
        }
        return ;
      }

      this.inboxesStore = inboxes_store;

      this.inboxesQuery = inboxes_store.ref;
      this.update({ isRefreshing: true });
      try {
        let items = await this.fetchInboxes();

        if (this.inboxesStore !== inboxes_store) return ;

        this.loadedInboxes = items;
        this.filterInboxes();
      }
      catch (e) {
        if (this.inboxesStore !== inboxes_store) return ;

        this.inboxesQuery = null;
        app.utils.confirmReload(e);
      }
      this.update({ isRefreshing: false });
    };

    this.createInboxesStore = (query) => {
      let inboxes_store = app.store.workspace_user.collection('inboxes')
        .limit(this.limit).orderBy('updated_at', 'desc')
        ;

      if (!query.options.closed) {
        inboxes_store.where('archived', '==', false);
      }
      if (query.options.unread) {
        inboxes_store.where('looked', '==', false);
      }
      if (query.options.favorite) {
        inboxes_store.where('favorite', '==', true);
      }
      if (query.options.assigned_id == app.auth.currentUser.uid) {
        inboxes_store.where('assigned', '==', true);
      }
      return inboxes_store;
    };

    this.fetchInboxes = async () => {
      let items = await this.inboxesStore.fetch();
      let results = await Promise.allSettled(items.map(item => item.relate()));
      results.forEach(({ status, reason }) => {
        if (status === 'rejected') {
          console.error(reason);
        }
      });
      return items.filter((item, i) => results[i].status === 'fulfilled');
    };

    this.filterInboxes = () => {
      let query = this.refs.filter.getQuery();
      let notes = app.utils.filterNotes(this.loadedInboxes.map(item => item.relation.note), query);
      this.activeInboxes = this.loadedInboxes.filter(item => notes.indexOf(item.relation.note) !== -1);
      this.updateCurrentInbox();
    };

    this.updateCurrentInbox = async (inbox_id) => {

      if (inbox_id) {

        this.currentInbox = this.activeInboxes.find(inbox => inbox.id === inbox_id);

        if (!this.currentInbox) {
          this.currentInbox = await app.store.workspace_user.collection('inboxes').doc(inbox_id).fetch({relation:true});
        }
      }

      else if (this.currentInbox) {

        this.currentInbox = this.activeInboxes.find(inbox => inbox.id === this.currentInbox.id) || this.currentInbox;
      }

      if (this.currentInbox) {
        this.refs.note.setNote(this.currentInbox.relation.note).catch(app.utils.confirmReload);
        this.refs.messages.setNote(this.currentInbox.relation.note).catch(app.utils.confirmReload);
        this.update();
      }
    };

    this.focusNoteFilter = () => {
      this.refs.filter.focus();
    };

    this.focusMessage = () => {
      this.refs.messages.focusEditor();
    };

    this.toggleUnread = () => {
      this.toggleUnreadFilter();

      this.refs.filter.refs.query.blur();
    };

    this.clickAssignedCheckbox = () => {
      this.refs.filter.clickAssignedCheckbox();
    };

    this.debouncedFetchMore = _.debounce(async () => {

      let last_item = this.inboxesStore.items[this.inboxesStore.items.length-1];

      if (last_item) {
        this.isLoading = true;
        this.update();

        let inboxes_store = this.inboxesStore;
        this.inboxesStore.startAfter(last_item.doc);
        try {
          let items = await this.fetchInboxes();

          if (this.inboxesStore === inboxes_store) {
            this.loadedInboxes.push(...items);
            this.filterInboxes();
          }
        }
        catch (e) {
          if (this.inboxesStore === inboxes_store) {
            app.utils.confirmReload(e);
          }
        }
        this.isLoading = false;
        this.update();
      }
    }, 128, true);

    this.onScroll = (e) => {
      let {scrollHeight , scrollTop, clientHeight} = e.currentTarget;
      let is_scroll_end = scrollHeight - scrollTop -2 <= clientHeight;
      e.preventUpdate = true;

      if (is_scroll_end) {
        this.debouncedFetchMore();
      }
    };

    this.shouldShowClosedNoteAnnouncement = () => {
      let { options } = this.refs.filter.getQuery();

      for (let key in options) {
        if (key !== 'unread' && options[key]) {
          return false;
        }
      }

      return options.unread && !this.activeInboxes.length && app.store.inboxesStore.items.length;
    };

    this.filterUnreadAndClose = () => {
      let q = 'unread:true closed:true';
      this.refs.filter.setQueryValue(q);
    };

    this.isUnreadFiltered = () => {
      let { options } = this.refs.filter.getQuery();
      return options.unread;
    };

    this.toggleUnreadFilter = () => {
      capacitor.hapticsImpactLight();

      let is_unread = this.isUnreadFiltered();
      let query = is_unread ? '' : 'unread:true';

      this.refs.filter.setQueryValue(query);
    };

    this.on('refresh', (e) => {
      app.utils.scrollToTop(this.refs.notes);
    });
});